
let language = {
    PC_RESOURCE_LIB_SET_PUT_LIB_ON_PRODUCT_TIP: "You can put a sticker or background or foreground on your product.",
    PC_RESOURCE_LIB_SET_NOT_SUPPORT_LIB_TIP: "This product does not support product sticker customization",
    PC_RESOURCE_LIB_OPEN_TO_SELECT_CUSTOM_FACE_TIP: "Please open the tree structure to select custom faces",
    PC_RESOURCE_LIB_CUSTOM_FACE_NOT_SUPPORT_PRODUCT_CUSTOMIZATION_TIP: "This custom face does not support product sticker customization",
    PC_RESOURCE_LIB_NO_MATCH_SEARCH_TIP: "There is no match for the search criteria.",
    PC_RESOURCE_LIB_IS_EMPTY_TIP: "Your current resource library is empty.",
    
    // 
    PC_RESOURCE_LIB_SAVE_SETTING_SUCCESS_TIP: "Save success.",
};

export { language }